/**
 * RESPONSIBILITY: one reason the House of Honor matters.
 *
 * Text only — no picture, no link. Three or four of these sit under the case for the
 * appeal, and a photo on each would compete with the single image already carrying the
 * page rather than add anything.
 */
import { Row, Text, Paragraph } from '@framework/core/decorators';

@Row()
export class Highlight {
  @Text({ label: 'Title', maxLength: 120 })
  title!: string;

  @Paragraph({ label: 'Description', maxLength: 400, rows: 2 })
  blurb!: string;
}
